import { FC } from 'react'
import Button from 'components/generic/Button/Button'
import { ListingType } from 'types/enums'
import { ViewerContextType } from 'contexts/ViewerContext'
import { USER_TYPES } from 'components/GetStarted/constants'
import ContentBlock from 'components/ContentBlock'
import Stack from '@careguide/stack'
import { Heading } from '@careguide/typography'

type ListingCTAProps = {
  listing: TODO
  viewer: ViewerContextType
}

const ListingCTA: FC<ListingCTAProps> = ({ listing, viewer }) => {
  const useNoListingHeading = !!viewer?.user?.userId && !viewer.hasActiveListing
  const listingOwnerName = listing?.user?.firstName
  const listingType = listing?.job ? ListingType.jobs : ListingType.profiles
  const defaultHeading =
    listingType === ListingType.jobs
      ? `Want to be hired by ${listingOwnerName}?`
      : `Want to connect with ${listingOwnerName}?`
  const defualtButtonLabel = listingType === ListingType.jobs ? `Apply Now` : `Get Started Now`
  const noListingHeading = `Create your profile to message ${listingOwnerName}`
  const noListingButtonLabel = 'Get Started'
  const userType = listing?.isProviderListing ? USER_TYPES.SEEKER : USER_TYPES.PROVIDER
  const listingPath = listing?.path

  return (
    <ContentBlock
      bg='gray.1'
      as='span' // Hack around conditional SSR where markup is messed up: issue here (https://github.com/styled-components/styled-components/issues/3125)
      borderRadius='small'
      p='4'
      pt='5'
    >
      <Stack gap='5'>
        <Heading as='h2' align='center'>
          {useNoListingHeading ? noListingHeading : defaultHeading}
        </Heading>
        <Button
          href={`/get-started/user-type?user_type=${userType}&return_url=${encodeURI(listingPath)}`}
        >
          {useNoListingHeading ? noListingButtonLabel : defualtButtonLabel}
        </Button>
      </Stack>
    </ContentBlock>
  )
}

export default ListingCTA
